import  React from 'react'
import { DashboardModel } from '../../../../../models/DashboardModel'
import { DashboardDetailModel } from '../../../../../models/DashboardDetailModel'
import { TableBody, TableColumn } from '../../../../../shared/table'
import { getFY } from '../../../../../shared/Utility'

export interface Props {
  model: DashboardModel
  handleApplicationClick: any
  searchTxt: string
}

export default class Agent extends React.Component<Props> {
  constructor(props: Props) {
    super(props)

    this.state = { }
  }

  render() {
    const {
      model, searchTxt, handleApplicationClick,
    } = this.props

    if (model?.dashboardDetailModels && model?.dashboardDetailModels?.length > 0) {
      const columns: TableColumn<DashboardDetailModel>[] = [
        { name: 'Round', content: (r) => <div style={{ whiteSpace: 'nowrap' }}>{getFY(+r.round)}</div>, title: 'Round represents the first financial year of the grant agreement' },
        { name: 'Applicant', content: (r) => `${r.organisationName}` },
        { name: 'Application ID', content: (r) => r.claimRandomIdentifier, responsive: 'md' },
        { name: 'Primary Contact', content: (r) => r.modifiedPrimaryContactName || r.primaryContactName, responsive: 'md' },
        { name: 'Agent Contact', content: (r) => r.modifiedAgentContactName || r.agentContactName },
        { name: 'Status', content: (r) => r.applicationStatus },
      ]
      return (
        <>
          <div className="row mt-4 mb-4">
            <div className="col-md-8">
              <div className="row">
                <div className="col-md-2 pr-0">
                  <strong>Agent</strong>
                </div>
                <div className="col-md-8 p-0">
                  {model.consultancyName}
                </div>
              </div>
            </div>
          </div>

          <TableBody<DashboardDetailModel>
            id="claims"
            columns={columns}
            value={
              model.dashboardDetailModels.filter(
                (r) => `${r.organisationName} ${r.claimRandomIdentifier} ${r.primaryContactName} ${r.agentContactName} ${r.applicationStatus}`.toLowerCase().indexOf(searchTxt.toLowerCase()) >= 0,
              )
              }
            alwaysShowAllRows
            rowClickCallback={{ fn: handleApplicationClick, param: 'applicationID' }}
            noRowsMessage="No search results returned"
          />
        </>
      )
    }
    return (
      <>
        <br />
        <strong>{'Agent: '}</strong>
        {model?.consultancyName}
        <br />
        <br />
        <span>{`You have not started an application for the financial year ${model?.financialYearName}`}</span>
      </>
    )
  }
}
